export default size => p => {
  const { fontSize } = p.theme.typography

  return fontSize[size].size + '; line-height:' + fontSize[size].lineHeight + ';'
}
